/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Toggle_MonthlyInputs */

const tr_pricing_toggle_monthly = /** @type {(inputs: Pricing_Toggle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık`)
};

const en_pricing_toggle_monthly = /** @type {(inputs: Pricing_Toggle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const de_pricing_toggle_monthly = /** @type {(inputs: Pricing_Toggle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const ru_pricing_toggle_monthly = /** @type {(inputs: Pricing_Toggle_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Pricing_Toggle_MonthlyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_toggle_monthly = /** @type {((inputs?: Pricing_Toggle_MonthlyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Toggle_MonthlyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_toggle_monthly(inputs)
	if (locale === "de") return de_pricing_toggle_monthly(inputs)
	if (locale === "ru") return ru_pricing_toggle_monthly(inputs)
	return tr_pricing_toggle_monthly(inputs)
});